import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { BatchRequestsService } from './api/batchRequests.service';
import { HeaderSetService } from './api/headerSet.service';
import { ItemsSetService } from './api/itemsSet.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class NotificationApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<NotificationApiModule> {
        return {
            ngModule: NotificationApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: NotificationApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('NotificationApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
